import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, SelectField } from "@/components/common";
import { OrderDialog } from "@/components/forms";
import { OrdersTable } from "@/components/tables";
import { useList } from "@/lib/hooks";
import { ORDER_CATEGORIES, ORDER_STATUS, todayStr } from "@/lib/constants";

export default function Orders() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState(params.get("status"));
  const [category, setCategory] = useState(null);
  const [open, setOpen] = useState(false);
  const { items, reload } = useList("/orders", { status: status || "", category: category || "" });
  const late = params.get("late") === "1";
  const shown = late ? items.filter((o) => o.status === "commande" && o.expected_date && o.expected_date < todayStr()) : items;

  return (
    <>
      <PageHeader title="Commandes de matériel" subtitle="PC, écrans, imprimantes, affichage dynamique…">
        <Button onClick={() => setOpen(true)} className="dt-glow" data-testid="new-order-button"><Plus className="mr-1 h-4 w-4" />Nouvelle commande</Button>
      </PageHeader>
      <div className="flex flex-col gap-3 sm:flex-row">
        <SelectField className="sm:w-48" value={status} onChange={setStatus} options={ORDER_STATUS} allowNone="Tous les états" testid="orders-status-filter" />
        <SelectField className="sm:w-56" value={category} onChange={setCategory} options={ORDER_CATEGORIES} allowNone="Toutes catégories" testid="orders-category-filter" />
      </div>
      {late && <p className="text-sm text-red-200" data-testid="orders-late-filter">Filtre : livraisons attendues dépassées</p>}
      <OrdersTable items={shown} reload={reload} />
      <OrderDialog open={open} onOpenChange={setOpen} initial={{}} onSaved={reload} />
    </>
  );
}
